<template>
  <!--root-->
  <div class="zzl-container">
    <div class="zzl-content">
      <!--账号管理-->
      <div class="zzl-title">账号管理</div>
      <div class="table-box">
        <!--账号列表-->
        <div class="zzl-subtitle">
          账号列表
          <!--添加账号-->
          <el-button
            :round="true"
            size="mini"
            :type="'primary'"
            @click.prevent="addUserModal"
            >添加账号</el-button
          >
        </div>
        <!--表格-->
        <div class="tableList">
          <el-table
            :data="userTableData"
            max-height="635px"
            @sort-change="changeTableSort"
          >
            <el-table-column
              prop="nickName"
              label="昵称"
              min-width="120px"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!--账户名-->
            <el-table-column
              prop="name"
              label="账户名"
              min-width="120px"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!--手机号-->
            <el-table-column
              label="手机号"
              min-width="120px"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ filterVal(scope.row.phone) }}</span>
              </template>
            </el-table-column>
            <!--角色-->
            <el-table-column
              label="角色"
              min-width="160px"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ findRoleDescription(scope.row.Roles) }}</span>
              </template>
            </el-table-column>
            <!--创建时间-->
            <el-table-column
              label="创建时间"
              min-width="120px"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ zzlFormat.getTimeDate(scope.row.createdTime) }}</span>
              </template>
            </el-table-column>
            <!--操作-->
            <el-table-column
              label="操作"
              min-width="120px"
              fixed="right"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <!--编辑-->
                <i
                  class="el-icon-edit"
                  style="margin-right: 35px; font-size: 16px; cursor: pointer"
                  title="编辑"
                  @click="userHandleCommonEdit(scope.row, scope)"
                ></i>
                <!--删除-->
                <i
                  class="el-icon-delete"
                  style="font-size: 16px; cursor: pointer"
                  title="删除"
                  @click="userHandleCommonDelete(scope.row, scope.$index)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex-end">
          <el-pagination
            :page-size="userPageSize"
            :total="userTotal"
            :current-page="userCurrentPage"
            :page-sizes="[10, 20, 30, 40]"
            @size-change="userSizeChange"
            @current-change="userCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible="userModal"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="userUpdateOrAddNum === 1 ? '添加管理用户' : '修改管理用户'"
      width="800px"
      custom-class="commentDialog"
      @close="closeUserModal"
    >
      <div class="formBox">
        <el-form
          ref="userForm"
          :model="userForm"
          :rules="userRules"
          label-position="top"
          label-width="100px"
        >
          <el-row :gutter="16">
            <!--昵称-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="nickName" label="昵称">
                <el-input
                  v-model="userForm.nickName"
                  placeholder="请输入昵称"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--账户名-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="name" label="账户名">
                <el-input
                  v-model="userForm.name"
                  placeholder="请输入账户名"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--邮箱-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="email" label="邮箱">
                <el-input
                  v-model="userForm.email"
                  placeholder="请输入邮箱"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--手机-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="phone" label="手机">
                <el-input
                  v-model="userForm.phone"
                  placeholder="请输入手机号"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--新密码-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="Pwd" label="新密码">
                <el-input
                  type="password"
                  v-model="userForm.Pwd"
                  placeholder="请输入新密码"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--重复新密码-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="password" label="重复新密码">
                <el-input
                  type="password"
                  v-model="userForm.password"
                  placeholder="再次输入密码"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--角色选择-->
            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <el-form-item prop="roles" label="角色选择">
                <el-select
                  v-model="userForm.roles"
                  :multiple="true"
                  :collapse-tags="true"
                  placeholder="请选择角色"
                >
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.ID"
                    :value="item.ID"
                    :label="item.RoleDescription"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--备注-->
            <el-col :span="24">
              <el-form-item prop="description" label="备注">
                <el-input
                  type="textarea"
                  v-model="userForm.description"
                  placeholder="请输入备注"
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="justify-content-center">
        <el-button :round="true" @click.prevent="resetForm">重置</el-button>
        <el-button
          :round="true"
          :type="'primary'"
          @click.prevent="confirm('userForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import hashes from "../../../static/js/hashes.min";

export default {
  name: "UserManagement",
  data() {
    return {
      userTableData: [],
      userPageSize: 20,
      userTotal: 0,
      userCurrentPage: 1,
      userModal: false,
      userForm: {
        nickName: "",
        roles: [],
        name: "",
        email: "",
        phone: "",
        Pwd: "",
        password: "",
        description: ""
      },
      userRules: {
        nickName: [{ required: true, message: "不能为空", trigger: "blur" }],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        Pwd: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                this.countValidate = true;
                callback();
              }
              if (
                value.length !== 0 &&
                (value.length < 5 || value.length > 13)
              ) {
                callback(new Error("密码长度为5至13位"));
              }
              let reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
              if (reg.test(value)) {
                this.countValidate = true;
                callback();
              } else {
                callback(new Error("密码必须由字母和数字组成"));
              }
            },
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            trigger: "blur",
            validator: (rule, _value, callback) => {
              if (this.userForm.Pwd === this.userForm.password) {
                callback();
              } else {
                callback(new Error("两次密码不一致"));
              }
            },
          },
        ],
        phone: [
          {
            required: false,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value == "" || value == undefined) {
                callback();
              } else {
                let reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
                if (!reg.test(value)) {
                  callback(new Error("格式不对"));
                } else {
                  callback();
                }
              }
            },
          },
        ],
        roles: [{ required: true, message: "不能为空", trigger: "change" }],
        email: [
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
      },
      roleOptions: [],
      userid: "",
      networkState: true,
      order: "created_time",
      by: 1,
      oldUserName: "",
      userUpdateOrAddNum: -1,
    };
  },
  computed: {
  },
  methods: {
    // 添加
    async addUserModal() {
      this.userUpdateOrAddNum = 1;

      this.userRules.Pwd[0].required = true;
      this.userRules.password[0].required = true;

      this.userModal = true;
    },
    // 修改
    async userHandleCommonEdit(_data, a, _num) {
      this.userUpdateOrAddNum = 2;

      this.userRules.Pwd[0].required = false;
      this.userRules.password[0].required = false;

      _data.Pwd = "";
      _data.password = "";
      let _row = JSON.parse(JSON.stringify(_data));
      console.log(_row, "ksks");
      this.userForm = _row;

      this.oldUserName = _row.Name;
      this.userModal = true;
    },
    // 提交
    confirm(formName) {
      if (!this.networkState) {
        this.$message.warning("网络繁忙");
        return;
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { Pwd } = this.userForm;
          if (Pwd !== "") {
            Pwd = new hashes.MD5().hex(this.userForm.Pwd + "_zzlfe25ec32c2d65");
          }
          this.userForm.Pwd = Pwd;

          if (this.userUpdateOrAddNum === 1) {
            this.addUser();
          } else {
            this.updateUser();
          }
        }
      });
    },
    // 添加账号
    async addUser() {
      const res = await this.zzlHttp.post(this.zzlApi.addUser, this.userForm);
      if (res.code === 0) {
        this.userModal = false;
        await this.getUserTableData();
        this.$message.success("添加成功");
      } else if (res.code === -1) {
        this.$message.error("用户已存在");
      } else {
        this.$message.error("添加失败" + res.msg);
      }
    },
    // 修改账号
    async updateUser() {
      const res = await this.zzlHttp.post(this.zzlApi.updateUser, this.userForm);
      if (res.code === 0) {
        if (this.userForm.Name !== this.oldUserName) {
          if (this.oldUserName === window.sessionStorage.getItem("whoIsUser")) {
            this.$message.warning("用户名发生修改，请重新登录");
            sessionStorage.clear();
            this.$router.push({ name: "login" });
            return;
          }
        }
        this.userModal = false;
        await this.getUserTableData();
        this.$message.success("修改成功");
      } else if (res.code === -1) {
        this.$message.error("用户已存在");
      } else {
        this.$message.error(res.msg);
      }
    },
    // 删除
    async userHandleCommonDelete(_data, _num) {
      this.$confirm("您正在执行删除操作", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.zzlHttp.post(this.zzlApi.deleteUser, {
            id: _data.id,
          });
          if (res.code === 0) {
            await this.getUserTableData();
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    // 重置
    reset(_refName) {
      this.userForm = {
        nickName: "",
        roles: [],
        name: "",
        email: "",
        phone: "",
        Pwd: "",
        password: "",
        description: "",
      };
      this.$refs[_refName].resetFields();
    },
    // 关闭模态框
    closeUserModal() {
      this.userModal = false;
      this.reset("userForm");
    },

    
    filterVal(val) {
      if (val) {
        return val;
      }
      return "--";
    },
    findRoleDescription(_val) {
      let roledesc = [];
      for (let item of _val) {
        for (let role of this.roleOptions) {
          if (item == role.id) {
            roledesc.push(role.description);
          }
        }
      }
      if (roledesc.length === 0) {
        return "--";
      }
      return roledesc.join(",");
    },
    // 查询
    async searchData() {
      this.table.pageNum = 1;
      await this.getUserTableData();
    },
    // 获取角色列表
    async getRole() {
      const res = await this.zzlHttp.post(this.zzlApi.getRoleList, {
        pageNum: 1,
        pageSize: 100,
        order: 7,
        by: 1,
      });
      if (res.code === 0 && res.data.list) {
        this.roleOptions = [];
        this.roleOptions = res.data.list;
      }
    },



    // 页码改变
    userCurrentChange(val) {
      this.table.pageNum = val;
      this.getUserTableData();
    },
    // 每页多少条改变
    userSizeChange(val) {
      this.table.pageSize = val;
      this.getUserTableData();
    },
    // 排序
    changeTableSort() {
      this.table.by = column.order === "ascending" ? 0 : 1;
      this.getUserTableData();
    },
    // 获取表格数据
    async getUserTableData() {
      let params = {
        pageNum: this.userCurrentPage,
        pageSize: this.userPageSize,
        by: 1,
        order: "created_time",
      };
      const res = await this.zzlHttp.post(this.zzlApi.getUserList, params);
      if (res.code === 0 && res.data.list) {
        this.userTotal = res.data.count || 0;
        for (let i in res.data.list) {
          res.data.list[i].CreatedTime = res.data.list[i].CreatedTime;
        }
        this.userTableData = res.data.list || [];
      } else {
        this.userTotal = 0;
        this.userTableData = [];
      }
    },
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: "系统正在努力加载,请耐心等待",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    await this.getRole();
    await this.getUserTableData();
    loading.close();
  },
};
</script>

<style scoped lang="scss">
.zzl-subtitle {
  position: relative;

  .el-button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.table-box {
  padding: 24px;
}
.justify-content-center {
  display: flex;
  justify-content: center;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
}
.tableList {
  margin-top: 16px;
}
</style>
